import ApiService from "../ApiService";

const documentService = {
  getDocuments() {
    return ApiService.get(`/identification-type`);
  },

  createDocument(formData) {
    return ApiService.post("/identification_type", formData);
  }
};

export default documentService;
